__turbopack_context__.v({
  "amount": "PreOrderSummaryRows-module-scss-module__WDjgLW__amount",
  "container": "PreOrderSummaryRows-module-scss-module__WDjgLW__container",
  "emphasized": "PreOrderSummaryRows-module-scss-module__WDjgLW__emphasized",
  "note": "PreOrderSummaryRows-module-scss-module__WDjgLW__note",
  "row": "PreOrderSummaryRows-module-scss-module__WDjgLW__row",
});
